import moment from 'moment-timezone';

export const getDateRanges = (callMetrics) => {
  let currentStart = callMetrics?.currentDateRange?.slice(0, 19) ?? '';
  let currentEnd = callMetrics?.currentDateRange?.slice(20) ?? '';
  let previousStart = callMetrics?.previousDateRange?.slice(0, 19) ?? '';
  let previousEnd = callMetrics?.previousDateRange?.slice(20) ?? '';
  currentStart = currentStart ? moment(currentStart).format('MMM Do') : '';
  currentEnd = currentEnd ? moment(currentEnd).format('MMM Do') : '';
  previousStart = previousStart ? moment(previousStart).format('MMM Do') : '';
  previousEnd = previousEnd ? moment(previousEnd).format('MMM Do') : '';
  const currentRange =
    !!currentStart && !!currentEnd ? `${currentStart} - ${currentEnd}` : '';
  const previousRange =
    !!previousStart && !!previousEnd ? `${previousStart} - ${previousEnd}` : '';
  return {
    currentRange,
    previousRange,
  };
};
